/*
 * Phone/tablet side menu = the desktop category bar.
 * The category bar (sections/osdtg-category-bar.liquid) is hidden below 990px, so copy its
 * categories into the header's menu drawer: each category opens to its sub-links and
 * "Shop all …". Page links from the Shopify main menu (Our Story, Reviews, My Orders…)
 * stay underneath; its collection links are dropped because the categories cover them.
 */
(function () {
  function text(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }

  function build() {
    var bar = document.querySelector('.osdtg-catbar');
    var menu = document.querySelector('.menu-drawer__navigation > ul.menu-drawer__menu');
    if (!bar || !menu || menu.dataset.osdtgCats) return;
    // Categories only; the bar's page links come from the main menu below.
    var items = bar.querySelectorAll('.osdtg-catbar__item:not(.osdtg-catbar__item--page)');
    if (!items.length) return;

    // Page links from the main menu (anything that isn't a collection / home / shop-all).
    // Same page links the desktop bar shows on its right (built from the main menu).
    var keep = [];
    bar.querySelectorAll('.osdtg-catbar__page').forEach(function (a) {
      keep.push({ href: a.getAttribute('href'), label: text(a) });
    });

    var html = '';
    items.forEach(function (item) {
      var top = item.querySelector('.osdtg-catbar__top');
      if (!top) return;
      var title = text(top);
      var subs = item.querySelectorAll('.osdtg-catbar__sub');
      if (!subs.length) {
        html += '<li><a class="menu-drawer__menu-item list-menu__item link link--text focus-inset" href="' +
          top.getAttribute('href') + '">' + title + '</a></li>';
        return;
      }
      var inner = '';
      subs.forEach(function (s) {
        if (s.tagName === 'A') {
          inner += '<li><a class="osdtg-dcat__link" href="' + s.getAttribute('href') + '">' + text(s) + '</a></li>';
        } else {
          inner += '<li><span class="osdtg-dcat__link osdtg-dcat__link--soon">' + text(s).replace(/\s*Soon$/, '') + ' <em>Soon</em></span></li>';
        }
      });
      var all = item.querySelector('.osdtg-catbar__all');
      if (all) inner += '<li><a class="osdtg-dcat__link osdtg-dcat__all" href="' + all.getAttribute('href') + '">' + text(all) + '</a></li>';
      html += '<li><details class="osdtg-dcat"><summary class="menu-drawer__menu-item list-menu__item link link--text focus-inset">' +
        title + '<svg aria-hidden="true" viewBox="0 0 10 10" width="12" height="12"><path d="M2 3.5l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>' +
        '</summary><ul class="osdtg-dcat__list" role="list">' + inner + '</ul></details></li>';
    });
    if (keep.length) {
      html += '<li class="osdtg-dcat__divider" aria-hidden="true"></li>';
      keep.forEach(function (k) {
        html += '<li><a class="menu-drawer__menu-item list-menu__item link link--text focus-inset osdtg-dcat__page" href="' +
          k.href + '">' + k.label + '</a></li>';
      });
    }
    menu.innerHTML = html;
    menu.dataset.osdtgCats = '1';

    // Our <summary> elements toggle on their own; keep Dawn's drawer handler from treating
    // them as its sliding submenus.
    menu.querySelectorAll('.osdtg-dcat > summary').forEach(function (s) {
      s.addEventListener('click', function (e) { e.stopPropagation(); }, true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
